import {FormatIcu} from '@tolgee/format-icu'
import {DevTools, Tolgee} from '@tolgee/react'
import skLocale from './messages/sk.json'
import csLocale from './messages/cs.json'
// English is per-site, not shared: the two brands word it differently and
// terapio carries keys ksebe doesn't. A single en.json held whichever site
// built last, so a failed download left one brand on the other's English.
import enKsebeLocale from './messages/en.ksebe.json'
import enTerapioLocale from './messages/en.terapio.json'

import {SITE_CONFIG} from './utils/helpers'

const isTerapio = SITE_CONFIG.isTerapio

// During next build, translations are pre-downloaded to messages/*.json by
// the download-tolgee-translations prebuild script. Skip CDN fetches to avoid
// 859+ network requests during SSG that cause timeouts and rate limits.
// Translations are pre-downloaded to messages/*.json by the prebuild step
// (download-tolgee-translations). No need for BackendFetch CDN calls during
// build or runtime — the static JSON files are the source of truth.
// BackendFetch was causing 859+ CDN requests during SSG, leading to
// rate limits and build timeouts.
// DevTools enables the in-context translation editor (browser-only).
// Only load it client-side and in development to avoid API calls during build/SSR.
const is_browser = typeof window !== 'undefined'
const is_dev = process.env.NODE_ENV === 'development'

let tolgeeInstance = Tolgee().use(FormatIcu())
if (is_browser && is_dev) {
  tolgeeInstance = tolgeeInstance.use(DevTools())
}

export const tolgee = tolgeeInstance.init({
  availableLanguages: isTerapio ? ['en', 'cs'] : ['en', 'sk'],
  defaultLanguage: isTerapio ? 'cs' : 'sk',
  // Credentials exist ONLY for the dev in-context editor (DevTools above).
  // NODE_ENV is statically replaced at build time, so this branch is dead code
  // in production and the key is never inlined into the client bundle — which
  // matters because NEXT_PUBLIC_TOLGEE_API_KEY is a write-scoped key and every
  // NEXT_PUBLIC_ value is served, as a string literal, to every visitor.
  // Production in-context editing goes through the Tolgee Tools Chrome
  // extension, which carries its own key entered by the user.
  ...(is_dev
    ? {
        apiKey: process.env.NEXT_PUBLIC_TOLGEE_API_KEY,
        apiUrl: process.env.NEXT_PUBLIC_TOLGEE_API_URL,
      }
    : {}),
  fallbackLanguage: isTerapio ? 'cs' : 'sk',
  // Not a fallback — this IS the source of truth. No BackendFetch plugin is
  // registered above, so nothing ever fetches from the CDN at runtime; the JSON
  // is refreshed at build time by the download-tolgee-translations prebuild
  // step. Because every locale is present here from init, `_app` does not pass
  // staticData to useTolgeeSSR — doing so inlined the same ~173 KB into every
  // page on top of the bundle.
  staticData: isTerapio
    ? {
        cs: csLocale,
        en: enTerapioLocale,
      }
    : {
        sk: skLocale,
        en: enKsebeLocale,
      },
})
